/* shah */
import React from 'react'

const ReadingMaskIcon = () => {
    return (
        <svg id="SmallBoxSVG-readingBook" version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            >
                <path d="M2391 5110 c-310 -65 -555 -291 -653 -600 -20 -66 -23 -95 -23 -240
0 -145 3 -174 23 -240 90 -285 297 -492 582 -582 66 -20 95 -23 240 -23 145 0
174 3 240 23 285 90 492 297 582 582 20 66 23 95 23 240 0 145 -3 174 -23 240
-89 283 -294 489 -577 580 -57 18 -98 23 -220 26 -82 2 -170 -1 -194 -6z"/>
                <path d="M1840 3271 c-183 -82 -477 -283 -443 -304 5 -3 268 -103 586 -222
l579 -217 581 218 c320 119 584 219 587 222 10 8 -94 93 -197 163 -93 62 -269
154 -329 173 -15 5 -40 -4 -82 -29 -133 -78 -306 -131 -464 -143 -237 -18
-454 28 -651 139 -38 22 -72 39 -75 38 -4 0 -45 -17 -92 -38z"/>
                <path d="M890 2792 c-19 -9 -45 -32 -57 -51 -22 -32 -23 -43 -23 -227 l0 -193
58 -6 c141 -15 218 -49 304 -136 112 -112 137 -205 137 -509 0 -304 -25 -397
-137 -509 -86 -87 -163 -121 -304 -136 l-58 -6 0 -182 c0 -163 2 -185 20 -214
10 -18 29 -39 42 -47 23 -14 1513 -576 1530 -576 4 0 8 513 8 1139 l0 1139
-711 266 c-391 146 -725 266 -742 266 -18 0 -48 -8 -67 -18z"/>
                <path d="M3418 2542 l-708 -266 0 -1138 c0 -626 4 -1138 8 -1138 17 0 1507
562 1530 576 13 8 32 29 42 47 18 29 20 51 20 214 l0 182 -57 6 c-142 15 -219
49 -305 136 -112 112 -137 205 -137 509 0 304 25 397 137 509 86 87 163 121
305 136 l57 6 0 193 c0 184 -1 195 -23 227 -27 41 -80 69 -127 68 -20 0 -340
-115 -742 -267z"/>
                <path d="M638 2005 c-95 -35 -182 -124 -214 -218 -24 -72 -16 -207 16 -272 31
-64 101 -134 165 -165 43 -22 67 -25 175 -28 141 -4 175 6 210 63 19 30 20 51
20 286 0 232 -2 256 -19 283 -38 57 -64 66 -196 65 -75 0 -134 -6 -157 -14z"/>
                <path d="M4176 2001 c-64 -43 -66 -50 -66 -330 0 -235 1 -256 20 -286 35 -57
69 -68 210 -63 108 3 132 7 175 28 64 31 134 101 165 165 22 43 25 64 25 155
0 91 -3 112 -25 155 -31 64 -101 134 -165 165 -44 22 -66 25 -180 28 -115 2
-133 0 -159 -17z"/>
            </g>
        </svg>
    )
}

export default ReadingMaskIcon